import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import AppBar from '../components/app-bar/AppBar'
import RegisterForm from '../components/app-form/RegisterForm'
import { withSnackbar } from 'notistack'

const styles = theme => ({
  container: {
    height: '100vh',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    flexDirection: 'column ',
  },
  welcome: {
    fontSize: 24,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
})

class RegisterV2 extends Component {
  state = {
    isFetching: false,
    user: window.state.user,
    initialEmail: window.state.initialEmail,
    errors: '',
    showForm: true,
  }

  redirect = (url, status) => {
    if (status === 'ok') {
      location.href = url
    }
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = ' /join/request'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const handleServerError = message => {
      this.setState({
        isFetching: false,
      })

      if (message.errors && message.status == 422) {
        this.setState({
          errors: message.errors,
        })
      } else {
        const error = `Произошла ошибка на сервере (${message.status}).
        Попробуйте снова или обратитесь в поддержку.`

        this.props.enqueueSnackbar(error, {
          variant: 'error',
          preventDuplicate: true,
          autoHideDuration: 6000,
        })
      }
    }

    function handleResponse(response) {
      return response.json().then(json => {
        if (response.ok) {
          return json
        } else {
          let error = Object.assign({}, json, {
            status: response.status,
            statusText: response.statusText,
          })

          return Promise.reject(error)
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ status }) => {
        if (status === 'ok') {
          this.setState({
            isFetching: false,
            showForm: false,
          })
        }
      })
      .catch(message => handleServerError(message))
  }

  render() {
    const { classes } = this.props
    const { user, errors, showForm } = this.state

    const islogin = user ? true : false

    return (
      <section className={classes.container}>
        <AppBar islogin={islogin} hideBtn={true} />
        <main className={classes.content}>
          {showForm && (
            <div
              style={{
                fontSize: 24,
                maxWidth: 510,
                textAlign: 'center',
                marginBottom: 72,
              }}
            >
              Зарегистрируйтесь и получите 14&nbsp;бесплатных дней на
              использование ROMI&nbsp;center
            </div>
          )}
          {!showForm && (
            <div className={classes.welcome}>
              Спасибо, мы свяжемся с вами и откроем доступы в кабинет.
            </div>
          )}
          {showForm && (
            <RegisterForm
              onSubmit={this.handleSubmit}
              isFetching={this.state.isFetching}
              errors={errors}
              initialValues={{
                email: this.state.initialEmail,
              }}
            />
          )}
        </main>
      </section>
    )
  }
}

export default withStyles(styles)(withSnackbar(RegisterV2))
